import { render } from "./TableBody.vue?vue&type=template&id=4776bef9&scoped=true"
import script from "./TableBody.vue?vue&type=script&lang=js"
export * from "./TableBody.vue?vue&type=script&lang=js"

import "./TableBody.vue?vue&type=style&index=0&id=4776bef9&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4776bef9"]])

export default __exports__